import axiosInstance from '../AxiosInstance';
import { fetchAllPagesVia } from '../paginated';

export function listEvents(params) {
    // FAZ 5 / F5-10 — uc sayfalandi; ekranda sayfalama arayuzu yok, tum
    // sayfalar cekiliyor. Cagiran sozlesmesi (`{ data: [...] }`) DEGISMIYOR.
    return fetchAllPagesVia(axiosInstance, '/events', params ?? {});
}

export function getActiveB2BEvent() {
    return axiosInstance.get('/events/b2b-active');
}

export async function getActiveB2BEventQuietly() {
    try {
        const response = await getActiveB2BEvent();
        return response?.data?.data ?? response?.data ?? null;
    } catch {
        return null;
    }
}

export function getActiveConnectEvent() {
    return axiosInstance.get('/events/connect-active');
}

export async function getActiveConnectEventQuietly() {
    try {
        const response = await getActiveConnectEvent();
        return response?.data?.data ?? response?.data ?? null;
    } catch {
        return null;
    }
}

/** Kullanicinin onayli katildigi (ya da yonettigi) B2B aktif etkinlikler. */
export function listMyB2BActiveEvents() {
    return axiosInstance.get('/events/b2b-active/mine');
}

/** Kullanicinin onayli katildigi (ya da yonettigi) Connect aktif etkinlikler. */
export function listMyConnectActiveEvents() {
    return axiosInstance.get('/events/connect-active/mine');
}

/** Etkinliğe özel destek hattı (WhatsApp/telefon + e-posta); herkese açık uç. */
export function getEventSupportContact(eventId) {
    return axiosInstance.get(`/public/events/${eventId}/support-contact`);
}

export function listMyEventParticipationStatuses() {
    return axiosInstance.get('/events/participation-statuses');
}

export function getEvent(eventId, params) {
    return axiosInstance.get(`/events/${eventId}`, { params });
}

export function updateEvent(eventId, payload) {
    return axiosInstance.patch(`/events/${eventId}`, payload);
}

export function getEventParticipationStatus(eventId) {
    return axiosInstance.get(`/events/${eventId}/participation-status`);
}

export function listEventAnnouncements(eventId, params) {
    return axiosInstance.get(`/events/${eventId}/announcements`, { params });
}

export function createEventAnnouncement(eventId, payload) {
    return axiosInstance.post(`/events/${eventId}/announcements`, payload);
}

export function updateEventAnnouncement(eventId, announcementId, payload) {
    return axiosInstance.patch(`/events/${eventId}/announcements/${announcementId}`, payload);
}

export function deleteEventAnnouncement(eventId, announcementId) {
    return axiosInstance.delete(`/events/${eventId}/announcements/${announcementId}`);
}

export function listBusinessEvents(businessId) {
    return axiosInstance.get(`/visitor-businesses/businesses/${businessId}/events`);
}

export function listBusinessExhibitorEvents(businessId) {
    return axiosInstance.get(`/businesses/${businessId}/events`);
}

export function joinEvent(eventId, businessId) {
    return axiosInstance.post('/visitor-businesses', { eventId, businessId });
}

export function listEventTicketTypes(eventId) {
    return axiosInstance.get(`/events/${eventId}/ticket-types`);
}

export function validateEventPromoCode(eventId, body) {
    return axiosInstance.post(`/events/${eventId}/promo-codes/validate`, body);
}

export function createEventTicketOrder(eventId, body) {
    return axiosInstance.post(`/events/${eventId}/ticket-orders`, body);
}

export function listMyEventTicketOrders(eventId) {
    return axiosInstance.get(`/events/${eventId}/ticket-orders`);
}

export function leaveEvent(eventId, businessId) {
    return axiosInstance.delete(`/visitor-businesses/${eventId}/${businessId}`);
}

export function listEventExhibitors(eventId) {
    return axiosInstance.get(`/events/${eventId}/exhibitors`);
}

export function listVisibleEventExhibitors(eventId) {
    return axiosInstance.get(`/events/${eventId}/exhibitors/visible`);
}

export function listAvailableEventExhibitors(eventId) {
    return axiosInstance.get(`/events/${eventId}/exhibitors/available`);
}

export function listExhibitorRegistrations(eventId) {
    return axiosInstance.get('/exhibitor-registrations', { params: { eventId } });
}

export function listPublicExhibitorRegistrations(eventId) {
    return axiosInstance.get('/public/exhibitor-registrations', { params: { eventId } });
}

export function listBusinessUsers(businessId) {
    return axiosInstance.get('/business-users', { params: { businessId } });
}

/**
 * ── TOPLU CAGRI — firma basina AYRI istek atmamak icin ──────────────────
 *
 * `listBusinessUsers` her firma icin bir istek demek. Firma listesi sayfasi
 * bunu dongude cagirinca 116 firmali bir hesapta SANIYEDE 116 istek cikiyordu
 * ve edge nginx'in `limit_req zone=api` esigi kullaniciya 429 dondurmeye
 * basliyordu. Bu fonksiyon ayni veriyi TEK istekte getirir.
 *
 * ⚠️ Sunucu tek istekte EN FAZLA 200 kimlik kabul ediyor
 *    (`business-users.controller.ts` → `MAX_BUSINESS_IDS`); asilirsa 400
 *    doner. Daha uzun listeler cagiran tarafta parcalanmali.
 */
export function listBusinessUsersByBusinessIds(businessIds) {
    const ids = Array.from(new Set((businessIds || []).map((id) => String(id ?? '').trim()).filter(Boolean)));
    return axiosInstance.get('/business-users', { params: { businessIds: ids.join(',') } });
}

export function listEventSessions(eventId, params) {
    return axiosInstance.get(`/events/${eventId}/spaces`, { params });
}

export function getEventSession(eventId, sessionId, params) {
    return axiosInstance.get(`/events/${eventId}/sessions/${sessionId}`, { params });
}

export function createSessionReservation(eventId, sessionId, payload) {
    return axiosInstance.post(`/events/${eventId}/sessions/${sessionId}/reservations`, payload);
}

export function updateSessionReservation(eventId, sessionId, reservationId, payload) {
    return axiosInstance.patch(`/events/${eventId}/sessions/${sessionId}/reservations/${reservationId}`, payload);
}

export function listSessionReservations(eventId, sessionId, params) {
    return axiosInstance.get(`/events/${eventId}/sessions/${sessionId}/reservations`, { params });
}

export function deleteSessionReservation(eventId, sessionId, reservationId, config) {
    const normalizedConfig =
        config && (config.params || config.headers || config.data || config.signal)
            ? config
            : config
              ? { params: config }
              : undefined;

    return axiosInstance.delete(
        `/events/${eventId}/sessions/${sessionId}/reservations/${reservationId}`,
        normalizedConfig,
    );
}

export function listSessionSpeakers(eventId, sessionId, params) {
    return axiosInstance.get(`/events/${eventId}/sessions/${sessionId}/speakers`, { params });
}

export function getHsVisibility() {
    return axiosInstance.get('/events/hs-visibility');
}
